import { View } from "binder"
import { ExecutableViewModel } from "../executable/executable-viewModel";
import { MethodBodyManipulatorViewModel } from "./methodBodyManipulator-viewModel"

export class MethodBodyManipulatorView extends View<MethodBodyManipulatorViewModel>{
    GetViewUniqueId(): string {
        return "V-36FDD390-9EC3-4FDE-B4D5-FB6780387B92"
    }
    loadHtml(): string {
        let element = require('./methodBodyManipulator.html').default;
        let style = require('./methodBodyManipulator.less');
        return element;
    }
    constructor() {
       super();
    }

    public set executable(v: ExecutableViewModel) { this._executable = v; } public get executable(): ExecutableViewModel { return this._executable;} private _executable: ExecutableViewModel;

}
